'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementsPropType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var elementsPropType = exports.elementsPropType = _propTypes2.default.shape({
  checked: _propTypes2.default.bool.isRequired
});

function withChartLegend(Component) {
  var WithChartLegend = function (_React$Component) {
    _inherits(WithChartLegend, _React$Component);

    _createClass(WithChartLegend, null, [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, state) {
        if (props.legend) {
          var nextElementsHash = btoa(JSON.stringify(props.legend.elements));

          // first call, or elements have changed
          if (!state || nextElementsHash !== state.dataHash) {
            return {
              elements: props.legend.elements,
              dataHash: nextElementsHash
            };
          }

          // no change
          return null;
        }

        // no legend
        return {
          elements: [],
          dataHash: null
        };
      }
    }]);

    function WithChartLegend(props) {
      _classCallCheck(this, WithChartLegend);

      var _this = _possibleConstructorReturn(this, (WithChartLegend.__proto__ || Object.getPrototypeOf(WithChartLegend)).call(this, props));

      _this.state = {
        elements: props.legend ? props.legend.elements : []
      };

      _this.toggleAllElements = _this.toggleAllElements.bind(_this);
      _this.toggleElement = _this.toggleElement.bind(_this);
      _this.getFilteredElements = _this.getFilteredElements.bind(_this);
      return _this;
    }

    _createClass(WithChartLegend, [{
      key: 'getFilteredElements',
      value: function getFilteredElements() {
        return this.state.elements.filter(function (element) {
          return element.checked;
        });
      }
    }, {
      key: 'toggleAllElements',
      value: function toggleAllElements(selectionState) {
        this.setState({
          elements: this.state.elements.map(function (element) {
            return _extends({}, element, {
              checked: selectionState
            });
          })
        });
      }
    }, {
      key: 'toggleElement',
      value: function toggleElement(toggledElement, selectionState) {
        var idKey = this.props.legend.idKey;


        this.setState({
          elements: this.state.elements.map(function (element) {
            if (element[idKey] === toggledElement[idKey]) {
              return _extends({}, element, {
                checked: selectionState
              });
            }

            return element;
          })
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            legend = _props.legend,
            childrenProps = _objectWithoutProperties(_props, ['legend']);

        if (legend) {
          var idKey = legend.idKey,
              labelKey = legend.labelKey;


          return _react2.default.createElement(Component, _extends({}, childrenProps, {
            legend: {
              idKey: idKey,
              labelKey: labelKey,
              elements: this.state.elements,
              filteredElements: this.getFilteredElements(),
              toggleElement: this.toggleElement,
              toggleAllElements: this.toggleAllElements
            }
          }));
        }

        return _react2.default.createElement(Component, childrenProps);
      }
    }]);

    return WithChartLegend;
  }(_react2.default.Component);

  WithChartLegend.propTypes = _extends({}, Component.propTypes, {
    legend: _propTypes2.default.shape({
      idKey: _propTypes2.default.string.isRequired,
      labelKey: _propTypes2.default.string.isRequired,
      elements: _propTypes2.default.arrayOf(elementsPropType).isRequired
    })
  });

  return WithChartLegend;
}

exports.default = withChartLegend;